import React from 'react';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';

import { BroadcastGuide } from '../components/BroadcastGuide';

export const BroadcastGuideProvider = ({ store, data }) => {
    return (
        <Provider store={store}>
            <BroadcastGuide {...data} />
        </Provider>
    );
};

BroadcastGuideProvider.propTypes = {
    store: PropTypes.object.isRequired,
    data: PropTypes.object
};
